/**
 * 半角英数字を全角英数字に変換する。
 * 地番・家屋番号の入力正規化に使用する。
 *
 * @param input 変換対象の文字列
 * @returns 半角英数字を全角英数字に置き換えた文字列
 */
export const toZenkaku = (input: string): string =>
  input.replace(/[A-Za-z0-9]/g, (s) =>
    String.fromCharCode(s.charCodeAt(0) + 0xfee0)
  );
